import * as Yup from 'yup';

const PagesFormSchema = Yup.object().shape({
  title: Yup.string().required('Required field'),
  content: Yup.string().required('Required field'),
  category: Yup.string().required('Required field'),
});

export default PagesFormSchema;
